import axios from "axios";
import { baseUrl } from './base'
import { token } from "./base";
import { message } from "antd";

// Auth Apis


export const logIn = async (formData) => {

    const data = new FormData();
    data.append("email", formData.email)
    data.append("password", formData.password)

    return await axios.post(`${baseUrl}/api/auth/login-admin`, data, {
        headers: {
            "content-Type": "application/json",
        },
    })
}


export const sendOtp = async (formData) => {
    
    const email = formData.otpEmail

    return await axios.post(`${baseUrl}/api/auth/forgot-password/send-otp?email=${email}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    })

}

export const verifyOtp = async (formData) => {
    // if(!formData.otp){
    //     return message.error("Please fill the verification code")
    // }
    const email = formData.otpEmail
    const otp = formData.otp

    return await axios.post(`${baseUrl}/api/auth/forgot-password/verify-otp?email=${email}&otp=${otp}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}


export const resetPassword = async (formData) => {

    const data = new FormData()
    data.append("email", formData.otpEmail)
    data.append("newPassword", formData.newPassword)
    data.append("confirmNewPassword", formData.confirmPassword)

    return await axios.post(`${baseUrl}/api/auth/admin/forgot-password`, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

// Profile apis

export const getProfile = async () => {

    return await axios.get(`${baseUrl}/api/admin/get`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}


export const updateProfile = async (profileData, adminProfileImage) => {
    const data = new FormData()
    data.append("firstName", profileData.firstName)
    data.append("lastName", profileData.lastName)
    if(adminProfileImage){
        data.append("image", adminProfileImage)
    }


    return await axios.patch(`${baseUrl}/api/admin/update`, data, {
        headers: {
            'Content-Type':  'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const updatePassword = async (passwordData) => {

    return await axios.patch(`${baseUrl}/api/admin/change-password`, passwordData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

// User Management Apis

export const getUsers = async () => {

    return await axios.get(`${baseUrl}/api/auth/users`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const deleteUser = async (user) => {
    console.log("Delete user", user)

    return await axios.delete(`${baseUrl}/api/auth/users/delete/${user.id}`, {
         headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const updateUser = async (id, data, time) => {

    return await axios.put(`${baseUrl}/api/auth/users/${id}?firstName=${data.firstName}&lastName=${data.lastName}&active=${data.active}&coins=${data.coins}&newPlan=${data.subscriptionPlan}&adminUpgradeExpiresAt=${time}`, {}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}


// Relation Category apis

export const getRelationCategory = async () => {

    return await axios.get(`${baseUrl}/api/filter-category/get/4`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${token}`
        }
    })
}


// export const getRelationCategory = async () => {

//     return await axios.get(`${baseUrl}/api/relationships/all`, {
//         headers: {
//             'Content-Type': 'application/json',
//             // 'Authorization': `Bearer ${token}`
//         }
//     })
// }

export const createRelationCategory = async (data) => {

    return await axios.post(`${baseUrl}/api/relationships/create`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const updateRelationCategory = async (id, data) => {

return await axios.put(`${baseUrl}/api/relationships/update/${id}`, data, {
    headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
    }
})
}

// export const deleteRelationCategory = async (category) => {

//     return await axios.delete(`${baseUrl}/api/relationships/delete/${category.id}`,{
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//         }
//     })    
// }

export const deleteRelationCategory = async (category) => {

        return await axios.delete(`${baseUrl}/api/filter-category/subcategory/delete/${category.id}`,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })    
    }



// Occassion category apis

export const getOccassionCategory = async () => {

    return await axios.get(`${baseUrl}/api/filter-category/get/2`, {
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${token}`
        }
    })
}



// export const getOccassionCategory = async () => {

//     return await axios.get(`${baseUrl}/api/occasions-category/all`, {
//         headers: {
//             'Content-Type': 'application/json',
//             // 'Authorization': `Bearer ${token}`
//         }
//     })
// }

export const createOccassionCategory = async (data) => {


return await axios.post(`${baseUrl}/api/occasions-category/create`, data, {
    headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
    }
})
}

export const deleteOccassionCategory = async (category) => {


    return await axios.delete(`${baseUrl}/api/filter-category/subcategory/delete/${category.id}`,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}


// export const deleteOccassionCategory = async (category) => {


//     return await axios.delete(`${baseUrl}/api/occasions-category/delete/${category.id}`,{
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`
//         }
//     })
// }

export const updateOccassionCategory = async (id, data) => {


    return await axios.put(`${baseUrl}/api/occasions-category/update/${id}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}

// filter categories apis

export const getFilterAllCategories = async () => {

    return await axios.get(`${baseUrl}/api/filter-category/get/all`, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export const createFilterCategory = async (data) => {

    return await axios.post(`${baseUrl}/api/filter-category/create`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const deleteFilterCategory = async (category) => {

    return await axios.delete(`${baseUrl}/api/filter-category/delete/${category.id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const editFilterCategory = async (id, data) => {

    return await axios.put(`${baseUrl}/api/filter-category/update/${id}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })

}

export const deleteSubCategory = async (sub) => {

    return await axios.delete(`${baseUrl}/api/filter-category/subcategory/delete/${sub.id}`,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}


// Promise Voucher apis

export const getPromiseVoucher = async (page, size) => {

    return await axios.get(`${baseUrl}/api/promise-vouchers/get/all?page=${page}&size=${size}`, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export const createPromiseVoucher = async (data) => {

    return await axios.post(`${baseUrl}/api/promise-vouchers/create`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}


export const editPromiseVoucher = async (id,values) => {

    return await axios.put(`${baseUrl}/api/promise-vouchers/update/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}
export const deletePromiseVoucher = async (voucher)=>{

    return await axios.delete(`${baseUrl}/api/promise-vouchers/delete/${voucher.id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const deleteAllVouchers = async () => {

    return await axios.delete(`${baseUrl}/api/promise-vouchers/bulk/delete`, {
         headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}


// global occasions

export const getGlobalOccasions = async () => {

    return await axios.get(`${baseUrl}/api/common-occasions/get/all`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const deleteGlobalOccasions = async (occasion) => {

    return await axios.delete(`${baseUrl}/api/common-occasions/delete/${occasion.id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const createGlobalOccasion = async (data) => {


    return await axios.post(`${baseUrl}/api/common-occasions/create`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
    }

    export const updateGlobalOccasion = async (id, data) => {

        return await axios.patch(`${baseUrl}/api/common-occasions/update/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        })
    }


    // Terms and Conditions

export const getTermsAndConditions = async () => {

    return axios.get(`${baseUrl}/terms-and-conditions/all`, {
        headers: {
            "content-Type": "application/json",
        },
      });

}

export const updateTermsAndConditions = async (id, formData) => {

    return await axios.put(
        `${baseUrl}/terms-and-conditions/update/${id}`,
        formData,
        {
          headers: {
            "content-Type": "application/json",
           
          },
        }
      );
}

export const createTermsAndConditions = async (formData) => {

    return await axios.post(
        `${baseUrl}/terms-and-conditions/create`,
        formData,
        {
          headers: {
            "content-Type": "application/json",
            
          },
        }
      );

}


// help and support


export const getHelpAndSuport = async () => {

    return axios.get(`${baseUrl}/api/helpandsupport/get/all`, {
        headers: {
            "content-Type": "application/json",
        },
      });

}


export const createSupportData = async (formData) => {

    return await axios.post(`${baseUrl}/api/helpandsupport/create`, formData, {
        headers: {
            "content-Type": "application/json",
        },
    })
}

export const updateSupportData = async (id, formData) => {

    return await axios.put(
        `${baseUrl}/api/helpandsupport/update/${id}`,
        formData,
        {
          headers: {
            "content-Type": "application/json",
           
          },
        }
      );
}

// Billing and Subscriptions

export const getSubscriptions = async () => {

    return await axios.get(`${baseUrl}/api/billing-subscriptions/get/all`, {
        headers: {
            "content-Type": "application/json",
          },
    })
}

export const deleteSubscription = async (subscription) => {

    return await axios.delete(`${baseUrl}/api/billing-subscriptions/delete/${subscription.id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const createSubscription = async (data) => {

    return await axios.post(`${baseUrl}/api/billing-subscriptions/create`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}

export const updateSubscription = async (id,data) => {

    return await axios.patch(`${baseUrl}/api/billing-subscriptions/update/${id}`,data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    })
}


// Notifications

export const getAllNotifications = async (page, size) => {

    return await axios.get(`${baseUrl}/api/notifications/all?page=${page}&size=${size}`, {
        headers: {
            "content-Type": "application/json",
          }
    })
}

export const deleteThisNotification = async (id) => {

    return await axios.delete(`${baseUrl}/api/admin/notification/delete/${id}`, {
        headers: {
            "content-Type": "application/json",
             'Authorization': `Bearer ${token}`
          }
    })
}


export const getAdminNotifications = async (page, size) => {

    return await axios.get(`${baseUrl}/api/admin/notification/all?page=${page}&size=${size}`, {
        headers: {
            "content-Type": "application/json",
            'Authorization': `Bearer ${token}`
          }
    })
}

export const sendNotification = async (data) => {
console.log("kdnaknda", data)
    return await axios.post(`${baseUrl}/api/admin/notification/send?title=${data.title}&body=${data.body}`,{}, {
        headers: {
            "content-Type": "application/json",
            'Authorization': `Bearer ${token}`
          }
    })
}


export const getUserNotification = async (id) => {

    return await axios.get(`${baseUrl}/api/notifications/get/user/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
          }
    })
}


// Query Management

export const getQueries = async () => {

    return await axios.get(`${baseUrl}/api/queries/get/all`, {
        headers: {
            "content-Type": "application/json",
          }
    })
}

export const updateQueryStatus = async (id) => {

    return await axios.patch(`${baseUrl}/api/queries/status/${id}?status=Actioned`,{
        headers: {
            "content-Type": "application/json",
            'Authorization': `Bearer ${token}`
          }
    })
}


// track voucher 

export const trackVoucher = async () => {

    return await axios.get(`${baseUrl}/api/sendvoucher/tracking`, {
        headers: {
            "content-Type": "application/json",
          }
    })
}




// Excel sheet upload 

export const bulkUpload = async (file) => {
    const data = new FormData()
    data.append("file", file)

    return await axios.post(`${baseUrl}/api/promise-vouchers/upload`, data, {
        headers: {
            "content-Type": "multipart/form-data",
            'Authorization': `Bearer ${token}`
          }
    })
}



// Predefined Layouts

export const getLayouts = async () => {

    return await axios.get(`${baseUrl}/api/layouts/get/all`, {
         headers: {
           "content-Type": "application/json",
          }
    })
}

export const createLayout = async (data) => {

    return await axios.post(`${baseUrl}/api/layouts/create`, data, {
        headers: {
          "content-Type": "multipart/form-data",
           'Authorization': `Bearer ${token}`
          }
    } )
}

export const editLayout = async (id, data) => {
console.log("data ", data)
    return await axios.patch(`${baseUrl}/api/layouts/update/${id}`, data, {
         headers: {
          "content-Type": "multipart/form-data",
           'Authorization': `Bearer ${token}`
          }
    })
}

export const deleteLayout = async (id) => {

    return await axios.delete(`${baseUrl}/api/layouts/delete/${id}`, {
          headers: {
          "content-Type": "application/json",
           'Authorization': `Bearer ${token}`
          }
    })
}